import React, {useEffect, useState} from "react";
import {reservationsActions, userActions, useSelector} from "inbooma-api";
import {moment} from "../../../../../../vendor";
import {Biscuit} from "../../../../../utils";
import t from "../../../../helpers/t";


const FindBookings = (props) => {
    const {clientId,dispatch,setReservation, setReservations,setReservationsPending,reservationsPending, language, setUserQuery, setReservationQuery, reservationQuery, setUsers,setUser} = props;
    const _reservations = useSelector(state => state["reservations"].getReservations);

    let _queryState = {
        timeStamp: 0,
        value: ""
    }
    useEffect(() => {
        if(!reservationsPending || _reservations.success === ''){
            return;
        }
        if(_reservations.success === true){
            setReservations(_reservations.data);
        }
        setReservationsPending(false);
    },[_reservations]);

    const searchbarHandlerInside = (ev) => {
        setReservation(null);
        setReservations(null);
        setReservationQuery(ev.target.value);              // just storing the query
        searchbarHandler(ev);             // this should cause the api query
    };

    const resetQuery = () => {
        setReservationQuery('');
        setReservation(null);
        setReservations(null);
        searchbarHandler('');
    };

    const searchbarHandler = (ev) => {

        let q;
        if(typeof ev.target !== 'undefined') {
            q = ev.target.value.toLowerCase();
        } else {
            q = '';
        }
        if(q !== ""){
            setUserQuery('');
            setUser(null);
            setUsers(null);
        }
        const minLength = 1;
        if (q.length >= minLength) {                                    // work user search only for values bigger or equal to the minimum length

            setTimeout(function () {

                let diff = Number(moment().format('x')) - _queryState.timeStamp;
                if (diff > 700 && _queryState.value === q) {                  // no changes after the last 700 ms -> user finished input -> start request
                    dispatch(reservationsActions.getReservations({
                        token: Biscuit.get('token'),
                        suffix:"",
                        filter: {
                            'order_nbr': q,
                            'client_id': clientId,
                            'find': "full",
                            sort: "begin",
                            direction: "desc"
                        },
                        parameters: {
                            headers: {
                                'Accept-Language': language,
                                'Content-Language': language
                            }
                        }
                    }));
                    setReservationsPending(true);
                }
            },800);
        }
        _queryState.timeStamp = Number(moment().format('x'));
        _queryState.value = q;
    };

    return (
        <>
            <div id="inb-c-main-access-bar__search" className="medium-5 float-left" style={{minWidth:"50%",paddingLeft:"30px"}}>
                <label style={{paddingLeft:"20px"}}>{t('order')}</label>
                <input type="text" placeholder="Auftrag suchen" value={reservationQuery} className="inb-input--transparent inb-input--search float-left" onChange={searchbarHandlerInside} style={{maxWidth:'90%',paddingLeft:"20px"}}/>

                {reservationQuery !== '' && <><div className="inb-search-close" onClick={resetQuery} style={{padding:"5px 10px 10px 10px"}}>
                    <a href="#" className="unset-filter">
                        <i className="fi fi-x"> </i>
                    </a>
                </div></>}
            </div>

        </>);
};

export default FindBookings;
